<template>
  <!-- Search Input -->
  <Skeletor v-if="loading" :shimmer="true" height="100vh" width="100vw" />
  <div v-else style="display: flex; flex-direction: column; gap: 12px">
    <div style="display: flex; flex-direction: column">
      <label style="margin: 0 0 5px 8px">Búsqueda</label>
      <input
        v-model="searchQuery"
        type="text"
        placeholder="Buscar por nombre, DNI o email"
        class="form-control"
        style="width: fit-content; min-width: 300px"
      />
    </div>

    <!-- User List -->
    <div v-if="filteredUsers.length" class="">
      <div v-for="user in filteredUsers" :key="user.id" class="user-item">
        <p style="margin: 0; font-weight: 700">
          {{ user.displayName }}
          <span style="font-weight: 500">{{
            `- ${user.email} - ${user.dni}`
          }}</span>
        </p>
        <button
          @click="openQrModal(user)"
          type="button"
          class="btn btn-primary"
          style="margin: 0; font-size: 14px"
        >
          Generar QR
        </button>
      </div>
    </div>

    <!-- Modal for QR Code -->
    <div v-if="showModal" class="modal">
      <div
        class="modal-content"
        style="
          display: flex;
          flex-direction: column;
          justify-content: center;
          align-items: center;
        "
      >
        <span @click="closeModal" class="close-btn">&times;</span>
        <p style="margin: 0; font-weight: 700">
          QR de {{ selectedUser.displayName }}
        </p>
        <vue-qrcode
          :value="selectedUser.link"
          tag="svg"
          :options="{ errorCorrectionLevel: 'Q', width: 200 }"
        ></vue-qrcode>
        <button @click="downloadQrImage" class="btn btn-primary">
          Descargar QR
        </button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "QrGenerator",
  data() {
    const data = JSON.parse(localStorage.getItem("userData"));

    return {
      tokenAuth: data.tokenAuth,
      users: [], // List of users to display
      showModal: false, // Controls the visibility of the QR modal
      selectedUser: null, // Stores the selected user
      loading: true,
      searchQuery: "", // Search query
    };
  },
  computed: {
    filteredUsers() {
      if (!this.searchQuery) {
        return this.users;
      }

      const query = this.searchQuery.toLowerCase();
      return this.users.filter(
        (user) =>
          (user.displayName?.toLowerCase() || "").includes(query) ||
          (user.email?.toLowerCase() || "").includes(query) ||
          (user.dni?.toLowerCase() || "").includes(query)
      );
    },
  },
  methods: {
    // Fetch users from API or Vuex store
    fetchUsers() {
      this.loading = true;
      this.$https
        .post("/hubspot/fetchUsersSaludsaAdmin", {
          tokenAuth: this.tokenAuth,
        })
        .then((response) => {
          if (response.data.code == 200) {
            this.users = response.data.users;
          } else {
            if (response.data.code == 401) {
              this.$toast.error(response.data.message, {
                position: "top-right",
                max: 10,
              });

              localStorage.removeItem("userData");
              this.$store.state.user = "";

              // Redirect to login page
              this.$router.push({ name: "Signin" });
            } else {
              this.loadBanco();
            }
          }
        })
        .catch((error) => {
          console.log("error", error);
        })
        .finally(() => {
          this.loading = false;
        });
    },

    // Open QR Modal when user clicks on a user's name
    openQrModal(user) {
      this.selectedUser = {
        ...user,
        link: `https://referidos.saludsa.com/venta/${user.promoCode}`,
      };
      this.showModal = true;
    },

    // Close the modal
    closeModal() {
      this.showModal = false;
      this.selectedUser = null;
    },

    // Download the QR code image
    downloadQrImage() {
      const qrElement = document.querySelector("svg");
      const svgData = qrElement.outerHTML;
      const canvas = document.createElement("canvas");
      const ctx = canvas.getContext("2d");
      const img = new Image();

      img.onload = () => {
        canvas.width = img.width;
        canvas.height = img.height;
        ctx.drawImage(img, 0, 0);
        const qrImage = canvas.toDataURL("image/png");

        const link = document.createElement("a");
        link.href = qrImage;
        link.download = `${this.selectedUser.displayName.replace(/\s+/g, "_")}_QR.png`;
        link.click();
      };

      img.src =
        "data:image/svg+xml;charset=utf-8," + encodeURIComponent(svgData);
    },
  },
  mounted() {
    this.fetchUsers(); // Call the method to fetch users when the component is mounted
  },
};
</script>

<style scoped>
/* Styles for the user list and modal */
.user-item {
  border: none;
  background-color: white;
  border-radius: 5px;
  padding: 10px 20px;
  margin-bottom: 10px;
  cursor: pointer;
  transition: all 0.3s;
  display: flex;
  justify-content: space-between;
  align-items: center;
}

.modal {
  position: fixed;
  top: 0;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.5);
  display: flex;
  justify-content: center;
  align-items: center;
  z-index: 1000;
}

.modal-content {
  background-color: white;
  padding: 20px;
  border-radius: 5px;
  text-align: center;
  max-width: 400px;
  width: 100%;
}

.close-btn {
  position: absolute;
  top: 10px;
  right: 10px;
  font-size: 30px;
  cursor: pointer;
}

.btn {
  margin-top: 20px;
  padding: 10px 20px;
  font-size: 16px;
  cursor: pointer;
}
</style>

<!-- <div v-if="users.length" class="">
    <div
      v-for="user in users"
      :key="user.userId"
      class="user-item"
      @click="openQrModal(user)"
    >
      <p style="margin: 0; font-weight: 700">
        {{ user.displayName }}
        <span style="font-weight: 500">{{
          `- ${user.email} - ${user.dni}`
        }}</span>
      </p>
      <button class="btn btn-primary" style="margin: 0; font-size: 14px">
        Generar QR
      </button>
    </div>
  </div> -->
